import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=5085f7bf&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Autocomplete.vue?vue&type=script&lang=js&"
export * from "./Autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5085f7bf",
  null
  
)

export default component.exports